<template>
  <div class="w-full flex flex-col">
    <div class="leading-[45px] bg-white py-0 px-5 flex flex-row justify-between items-center">
      <div>聚合表</div>
      <div>
        <el-button :loading="loading" icon="el-icon-plus" type="primary" size="small" @click="onAdd">新增聚合表</el-button>
      </div>
    </div>
    <div class="content-detail overflow-y-auto">
      <div class="aggregate-list grid grid-cols-1 md:grid-cols-3">
        <div v-for="item in aggregates" class="aggregate-item m-[10px] shadow-white rounded bg-white h-28 text-sm">
          <div class="content-head h-11 border-b flex flex-row justify-between items-center">
            <div class="head-left flex-row flex">
              <i class="bi bi-table my-0 ml-[15px] mr-[6px]" />
              <div class="head-title font-bold">{{ item.name }}</div>
            </div>
            <div class="head-right">
              <Link :href="zroute('app.aggregate.edit', [app_id, item.id])"><i class="el-icon-edit" /></Link>
              <i class="bi bi-trash mx-2" />
            </div>
          </div>
          <div class="content-body h-[66px] py-[10px] px-[15px] text-gray-400 text-xs">
            <div class="info-heads">
              <span>根据「</span><span class="info-text">{{ item.heads.join(',') }}</span><span>」</span>
            </div>
            <div class="info-values">
              <span>计算「</span><span class="info-text">{{
                item.values.join(',')
              }}</span><span>」</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Layout from '@/Shared/Layout'
import axios from 'axios'
import zroute from '../../ziggy'
import {Link} from '@inertiajs/inertia-vue'

export default {
  name: 'Aggregate',
  components: {
    Link,
  },
  layout: Layout,
  props: {
    aggregates: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      app_id: zroute().params.app_id,
      loading: false,
    }
  },
  methods: {
    onAdd() {
      this.loading = true
      axios.post(zroute('app.aggregate.create', [this.app_id])).then(res => {
        this.loading = false
        this.$inertia.visit(zroute('app.aggregate.edit', [this.app_id, res.data.id]))
      })
    },
  },
}
</script>

<style scoped>

</style>
